import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = () => ({
  root: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translateX(-50%) translateY(-50%)',
    zIndex: 1300,
  },
  rootFixed: {
    position: 'fixed',
    marginTop: 32,
  },
});

const Progress = ({ className, fixed, classes, ...otherProps }) => (
  <CircularProgress
    className={classNames(classes.root, className, {
      [classes.rootFixed]: fixed,
    })}
    size={60}
    {...otherProps}
  />
);

Progress.propTypes = {
  className: PropTypes.string,
  fixed: PropTypes.bool,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    rootFixed: PropTypes.string.isRequired,
  }).isRequired,
};

Progress.defaultProps = {
  className: '',
  fixed: false,
};

export default withStyles(styles)(Progress);



// WEBPACK FOOTER //
// ./src/components/common/Progress.js